import { Controller } from "stimulus"

// NOTE: @hotwired/turbo 7.0.0-rc.1 does not auto-abort prior in-flight
// requests to the same frame. We patch fetch to attach an AbortController
// signal, ensuring stale responses never render. Can be removed if Turbo
// is upgraded to 7.3+.

const nativeFetch = window.fetch.bind(window)

export default class extends Controller {
  static targets = ["input"]

  initialize() {
    this.timeout = null
    this.abortController = null
  }

  search() {
    clearTimeout(this.timeout)

    if (this.inputTarget.value.trim() === "") {
      this.submit()
      return
    }

    this.timeout = setTimeout(() => {
      this.submit()
    }, 300)
  }

  submitNow(event) {
    if (event.key !== "Enter") return

    event.preventDefault()
    clearTimeout(this.timeout)
    this.submit()
  }

  submit() {
    if (this.abortController) this.abortController.abort()
    this.abortController = new AbortController()
    const signal = this.abortController.signal

    window.fetch = (url, options = {}) => {
      window.fetch = nativeFetch
      return nativeFetch(url, { ...options, signal })
    }

    this.element.requestSubmit()
    Promise.resolve().then(() => { window.fetch = nativeFetch })
  }
}
